import { EmployeeHasSupplementaryBenefitsType } from 'common/types';

export const allowedHasSupplementaryBenefitsValues: EmployeeHasSupplementaryBenefitsType[] =
  ['yes', 'no', 'unknown'];
